const firebaseConfig = {
    apiKey: "AIzaSyC0LKrFQBbE1eNTqVGPq9EmDS6MEQQRxjU",
    authDomain: "hunger-s-garage.firebaseapp.com",
    projectId: "hunger-s-garage",
    storageBucket: "hunger-s-garage.appspot.com",
    messagingSenderId: "622166125621",
    appId: "1:622166125621:web:663b6464d49d544d47157c"
  };
  export default firebaseConfig;